export default "__VITE_ASSET__UmtUmh4x__"